import React,{useState} from 'react';
import axios from 'axios';
import {apiUrl} from './apiAmbiente';
import Logo from '../assets/MB_Logo.png';

export default function FormularioSenha({chave}) {
  const redefinir=typeof chave==='string';
  const [email,setEmail]=useState(''),[senha,setSenha]=useState(''),[confirmacao,setConfirmacao]=useState('');
  const [enviando,setEnviando]=useState(false),[erro,setErro]=useState(''),[mensagem,setMensagem]=useState('');
  async function enviar(e) {
    e.preventDefault();if(enviando)return;setErro('');setMensagem('');
    if(redefinir&&senha!==confirmacao){setErro('As senhas precisam ser iguais.');return;}
    setEnviando(true);
    try {
      const form=new FormData();
      if(redefinir){form.set('chave',chave);form.set('pass',senha);}else{form.set('email',email.trim());}
      const {data}=await axios.post(apiUrl(redefinir?'resetsenha.php':'RecuperarSenha.php'),form);
      if(!data?.ok)throw new Error(data?.erro||'Não foi possível concluir. Tente novamente.');
      setMensagem(data.mensagem);setSenha('');setConfirmacao('');
      if(redefinir)sessionStorage.removeItem('KEY_APP_BGG');
    }catch(err){setErro(err.response?.data?.erro||err.message||'Falha de conexão. Tente novamente.');}
    finally{setEnviando(false);}
  }
  return <div className="limiter"><div className="container-login100" style={{backgroundImage:'url("/images/bg-3.webp")'}}><div className="wrap-login100">
    <form className="login100-form" onSubmit={enviar}>
      <span className="login100-form-logo"><img className="imglogo" src={Logo} alt="MB Hair"/></span>
      <h1 className="login100-form-title p-t-27 p-b-20">{redefinir?'Nova senha':'Recuperar senha'}</h1>
      {!mensagem&&<>
        {!redefinir?<><p className="txt1 p-b-20">Informe o e-mail cadastrado na sua conta.</p><div className="wrap-input100"><input className="input100" type="email" name="email" aria-label="E-mail cadastrado" placeholder="E-mail cadastrado" autoComplete="email" required maxLength={255} value={email} onChange={e=>setEmail(e.target.value)} disabled={enviando}/></div></>:<>
          <div className="wrap-input100"><input className="input100" type="password" name="senha" aria-label="Nova senha" placeholder="Nova senha" autoComplete="new-password" required minLength={6} maxLength={4096} value={senha} onChange={e=>setSenha(e.target.value)} disabled={enviando}/></div>
          <div className="wrap-input100"><input className="input100" type="password" name="confirmacao" aria-label="Confirmar nova senha" placeholder="Confirmar nova senha" autoComplete="new-password" required minLength={6} maxLength={4096} value={confirmacao} onChange={e=>setConfirmacao(e.target.value)} disabled={enviando}/></div>
          <p className="txt1 p-b-20">A senha deve conter pelo menos 6 caracteres.</p>
        </>}
        <div className="container-login100-form-btn"><button className="login100-form-btn" type="submit" disabled={enviando}>{enviando?'Aguarde...':redefinir?'Alterar senha':'Enviar link de recuperação'}</button></div>
      </>}
      {erro&&<p className="pError p-t-20" role="alert">{erro}</p>}
      {mensagem&&<p className="txt1 p-t-20" role="status">{mensagem}</p>}
      <div className="text-center p-t-20"><a className="txt1" href="/login">Voltar ao login</a>{redefinir&&<><br/><a className="txt1" href="/recuperar-senha">Solicitar novo link</a></>}</div>
    </form>
  </div></div></div>;
}
